import React from 'react';

import { Breadcrumb as AntBreadcrumb } from 'antd';
import { BreadcrumbProps } from 'antd/lib/breadcrumb';

import BreadcrumbItem from './BreadcrumbItem';
import BreadcrumbSeparator from './BreadcrumbSeparator';

export interface IBreadcrumbProps extends BreadcrumbProps {}

type TBreadcrumbs = React.FC<IBreadcrumbProps> & {
  Item: typeof BreadcrumbItem;
  Separator: typeof BreadcrumbSeparator;
};

/**
 * Breadcrumb component
 */
export const Breadcrumb: TBreadcrumbs = (props) => <AntBreadcrumb {...props} />;

Breadcrumb.Item = BreadcrumbItem;
Breadcrumb.Separator = BreadcrumbSeparator;
